import mixins from 'synergycms_core/src/less/mixins';

export default {
  inputCheck: {
    position: 'relative',
    width: '16px',
    height: '16px',
    display: 'inline-block',
    marginRight: '5px',
    verticalAlign: 'middle',
    ...mixins.transition(),
    '&:before': {
      top: '6px',
      left: '0px',
      content: "'\\e046'",
      position: 'absolute',
      width: '100%',
      height: '100%',
      font: '1px/1px Icons',
      color: 'transparent',
      textAlign: 'center'
    },
    '&:after': {
      width: '15px',
      height: '15px',
      top: '-2px',
      left: '-1px',
      border: '1px solid #ddd',
      position: 'absolute',
      content: "''",
      ...mixins.boxShadow('0 0 9px -3px rgba(0,0,0,1)')
    },
    '&:lang(ar)':{
      marginLeft:'15px',
      marginRight: 0
    }
  },
  visibilityHidden: {
    visibility: 'hidden'
  },
  checked: {
    '&:before': {
      color: data => data.mainColor,
      fontSize: '11px'
    }
  }
};
